module.exports = __webpack_public_path__ + "static/media/page-title-bar.3ed966eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-title-bar.jpg
// module id = 364
// module chunks = 33